const React = require('react');

import FormItemButton from '../formItem/FormItemButton';
import FormItemMenuItemButton from '../formItem/FormItemMenuItemButton';
//import FormItemTabPage from '../formItem/FormItemTabPage';
import FormItemGroup from '../formItem/FormItemGroup';
import FormItemTab from '../formItem/FormItemTab';
import FormItemDataGrid from '../formItem/FormItemDataGrid';
import FormItemButtonGroup from '../formItem/FormItemButtonGroup';
import FormItemFieldGroup from '../formItem/FormItemFieldGroup';
import FormItemImage from '../formItem/FormItemImage';
import FormItemStringEditor from '../formItem/FormItemStringEditor';
import FormItemDateEditor from '../formItem/FormItemDateEditor';
import FormItemTimeEditor from '../formItem/FormItemTimeEditor';
import FormItemEnumEditor from '../formItem/FormItemEnumEditor';
import FormItemBooleanEditor from '../formItem/FormItemBooleanEditor';

import FormItemDesignControl from '../formItem/controls/FormItemDesignControl';
import FormItemGroupControl from '../formItem/controls/FormItemGroupControl';
import FormItemTabControl from '../formItem/controls/FormItemTabControl';
import FormItemTabPageControl from '../formItem/controls/FormItemTabPageControl';
import FormItemDataGridControl from '../formItem/controls/FormItemDataGridControl';
import FormItemButtonGroupControl from '../formItem/controls/FormItemButtonGroupControl';
import FormItemFieldGroupControl from '../formItem/controls/FormItemFieldGroupControl';
import FormItemStringEditorControl from '../formItem/controls/FormItemStringEditorControl';
import FormItemDateEditorControl from '../formItem/controls/FormItemDateEditorControl';
import FormItemTimeEditorControl from '../formItem/controls/FormItemTimeEditorControl';
import FormItemDateTimeEditorControl from '../formItem/controls/FormItemDateTimeEditorControl';
import FormItemEnumEditorControl from '../formItem/controls/FormItemEnumEditorControl';
import FormItemBooleanEditorControl from '../formItem/controls/FormItemBooleanEditorControl';
import FormItemDecimalEditorControl from '../formItem/controls/FormItemDecimalEditorControl';
import FormItemLongEditorControl from '../formItem/controls/FormItemLongEditorControl';
import FormItemButtonControl from '../formItem/controls/FormItemButtonControl';
import FormItemButtonMenuControl from '../formItem/controls/FormItemButtonMenuControl';
import FormItemMenuItemButtonControl from '../formItem/controls/FormItemMenuItemButtonControl';
import FormItemDividedBoxControl from '../formItem/controls/FormItemDividedBoxControl';
import FormItemImageControl from '../formItem/controls/FormItemImageControl';
import FormItemPluginControl from '../formItem/controls/FormItemPluginControl';
import FormItemTextControl from '../formItem/controls/FormItemTextControl';
import FormItemTableCellControl from '../formItem/controls/FormItemTableCellControl';
import FormItemTableRowControl from '../formItem/controls/FormItemTableRowControl';
import FormItemTableControl from '../formItem/controls/FormItemTableControl';


import FormItemStringEditorForDataGrid from '../formItem/FormItemStringEditorForDataGrid';
import FormItemDateEditorForDataGrid from '../formItem/FormItemDateEditorForDataGrid';
import FormItemTimeEditorForDataGrid from '../formItem/FormItemTimeEditorForDataGrid';
//import FormItemDateTimeEditorForDataGrid from '../formItem/FormItemDateTimeEditorForDataGrid';
import FormItemBooleanRender from '../formItem/renders/FormItemBooleanRender';
import FormItemEnumEditorForDataGrid from '../formItem/FormItemEnumEditorForDataGrid';
import FormItemLongEditorForDataGrid from '../formItem/FormItemLongEditorForDataGrid';
import FormItemDecimalEditorForDataGrid from '../formItem/FormItemDecimalEditorForDataGrid';

import FormItemDividedBox from '../formItem/FormItemDividedBox';

import ArrayUtil from './ArrayUtil';
import FormItemSubFormButtonControl from '../formItem/controls/FormItemSubFormButtonControl';


class FormItemUtil
//module.exports = 
{
      static formItemControlsForFor = {};
      static formItemControls = {};
      static moduleLookupControls = {};

      static initFormItemControls(menuItemId,formId,parent,formItem,formDataSources,forLookup)
      {
            //console.log(formItem);
            var dataSourceName = "";
            if(formItem.Properties.hasOwnProperty("DataSource"))
                  dataSourceName = formItem.Properties.DataSource.Value;
           

            if(formItem.type == "DataGrid")
            {
                  window.formHasDataGrid = true;
            }

            if(formItem.type == "DataGrid" && dataSourceName == "")
            {
                  if(formItem.FormItem.length>0)
                  {
                        let dataGridColItem = formItem.FormItem[0];
                        dataSourceName = dataGridColItem.Properties.DataSource.Value;
                  }
            }
            var formDataSource;
            if(formDataSources.sources.hasOwnProperty(dataSourceName))
                  formDataSource=formDataSources.sources[dataSourceName];
         
            var control = FormItemUtil.getFormItemControls(menuItemId,formId,parent,formItem,
                  (formDataSource != undefined && formDataSource != null)?formDataSource.group:null,formDataSources.formModule,forLookup);
            if(forLookup)
            {
                  FormItemUtil.moduleLookupControls[menuItemId+"."+formId+"."+formItem.id] = control;
                  FormItemUtil.moduleLookupControls[menuItemId+"."+formId+"."+formItem.name] = control;
            }
            else
            {
                  FormItemUtil.formItemControls[menuItemId+"."+formId+"."+formItem.id] = control;
                  FormItemUtil.formItemControls[menuItemId+"."+formId+"."+formItem.name] = control;
                  FormItemUtil.formItemControls[control.controlId] = control;
                  FormItemUtil.formItemControlsForFor[control.controlId] = control;
            }
            
            if(formItem.hasOwnProperty("FormItem"))
            {
                  for(var i in formItem.FormItem)
                  {
                     var item = formItem.FormItem[i];
                     var childControl = FormItemUtil.initFormItemControls(menuItemId,formId,formItem,item,formDataSources,forLookup);
                     childControl.parentControl = control;
                     control.childrenControl.push(childControl);
                  }      
            }
            return control;
            
      }

      static getFormItemControlByDataField(dataField)
      {
            for(var key in FormItemUtil.formItemControlsForFor)
            {
                  var formItemControl = FormItemUtil.formItemControlsForFor[key];
                  if(typeof(formItemControl.getDataField) == "function")
                  {
                        let controlDataField = formItemControl.dataField;
                        if(controlDataField == dataField)
                              return formItemControl;
                  }
            }
            return null;
      }

      static hasUpDownDataGrid()
      {
            for(var key in FormItemUtil.formItemControlsForFor)
            {
                  var formItemControl = FormItemUtil.formItemControlsForFor[key];
                  if(formItemControl.classAlias == "FormItemDataGridControl")
                  {
                        let bool = FormItemUtil.doHasUpDownDataGrid(formItemControl.parentControl);
                        if(bool == true)
                              return true;
                  }
            }
            return false;
      }

      static hasDividedBox()
      {
            for(var key in FormItemUtil.formItemControlsForFor)
            {
                  var formItemControl = FormItemUtil.formItemControlsForFor[key];
                  if(formItemControl.classAlias == "FormItemDividedBoxControl")
                  {
                        return true;
                  }
            }
            return false;
      }

      static doHasUpDownDataGrid(parentControl)
      {
            if(!parentControl) return false;
            if(parentControl.getProperty_Layout() == "vertical")
            {
                  let result = [];
                  FormItemUtil.descendantsTowGrid(parentControl,result);
                  if(result.length>1)
                        return true;
                  //if(FormItemUtil.descendantsTowGrid(parentControl,0))
                  //      return true;
            }
            return FormItemUtil.doHasUpDownDataGrid(parentControl.parentControl);
      }

      //TODO Tab下面一定是TabPage 所以在向上索引父级的时候 跳过Tab 因为TabPage这一级已经可以完成该判断
      static descendantsTowGrid(parentControl,result)
      {
            let children = parentControl.childrenControl;
            if(children)
            {
                  for(let i = 0;i<children.length;i++)
                  {
                        let childControl = children[i];
                        if(childControl.classAlias == "FormItemDataGridControl")
                        {
                              if(!FormItemUtil.test(result,childControl))result.push(childControl);
                        }
                        if(result.length>1)
                              return;
                       FormItemUtil.descendantsTowGrid(childControl,result);
                  }
            }
      }

      //判断datagrid是否在同一个tab的不同选项卡上 
      static test(array,gridControl)
      {
            if(array.length==0)return false;
            let sourceGridControl = array[array.length-1];
            let sourceTabControl;let sourceTabPageControl;
            let parentControl = sourceGridControl.parentControl;
            while(parentControl.classAlias!="FormItemDesignControl")
            {
                  if(parentControl.classAlias == "FormItemTabPageControl")
                        sourceTabPageControl = parentControl;
                  if(parentControl.classAlias == "FormItemTabControl")
                  {
                        sourceTabControl = parentControl;
                        break;
                  }
                  parentControl = parentControl.parentControl;
            }
            if(!sourceTabControl)return false;

            let targetTabControl;let targetTabPageControl;
            parentControl = gridControl.parentControl;
            while(parentControl.classAlias != "FormItemDesignControl")
            {
                  if(parentControl.classAlias == "FormItemTabPageControl")
                        targetTabPageControl = parentControl;
                  if(parentControl.classAlias == "FormItemTabControl")
                  {
                        targetTabControl = parentControl;
                        break;
                  }
                  parentControl = parentControl.parentControl;
            }

            if(!targetTabControl)return false;

            if(sourceTabControl == targetTabControl && sourceTabPageControl != targetTabPageControl)
                  return true;
            return false;
      }

      //menuItemId+"."+formId+"."+formItem.id
      static getFormItemControl(key,forLookup)
      {
            if(forLookup)
            {
                  return FormItemUtil.moduleLookupControls[key];
            }
            else
            {                  
                  return FormItemUtil.formItemControls[key];      
            }
            
      }

      static getFormItemControls(menuItemId,formId,parent,item,groupAlias,module,forLookup)
      {
           if(item.name == "Design")
                  return new FormItemDesignControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
           var type = item.type;
           if(type == "Group")
                  return new FormItemGroupControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            if(type == "Tab")
                  return new FormItemTabControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            if(type == "TabPage")
                  return new FormItemTabPageControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            if(type == "DataGrid")
                  return new FormItemDataGridControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            if(type == "Image")
                  return new FormItemImageControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "Button")
                  return new FormItemButtonControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "SubFormButton")
                  return new FormItemSubFormButtonControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "ButtonMenu")
                  return new FormItemButtonMenuControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "MenuItemButton")
                  return new FormItemMenuItemButtonControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "ButtonGroup")
                  return new FormItemButtonGroupControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "FieldGroup")
                  return new FormItemFieldGroupControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "StringEditor")
                  return new FormItemStringEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "DateEditor")
                  return new FormItemDateEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "TimeEditor")
                  return new FormItemTimeEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "DateTimeEditor")
                  return new FormItemDateTimeEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "EnumEditor")
                  return new FormItemEnumEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "BooleanEditor")
                  return new FormItemBooleanEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "DecimalEditor")
                  return new FormItemDecimalEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "LongEditor")
                  return new FormItemLongEditorControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "DividedBox")
                  return new FormItemDividedBoxControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "Plugin")
                  return new FormItemPluginControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "Text")
                  return new FormItemTextControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "TableCell")
                  return new FormItemTableCellControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "TableRow")
                  return new FormItemTableRowControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            else if(type == "Table")
                  return new FormItemTableControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
            return new FormItemButtonControl(menuItemId,formId,parent,item,groupAlias,module,forLookup);
      }

      static getFormStoresKey(menuItemId,formId)
      {
            return menuItemId+"."+formId;
      }

      static getFormItemControlKey(menuItemId,formId,itemId)
      {
            return menuItemId+"."+formId+"."+itemId;
      }

      static getFormModuleCallerKey(menuItem,itemId)
      {
            return menuItemId+"."+itemId;
      }

      static getFormItemInstanceForDataGrid(item,forLookup)
      {
      	let type = item.type;
      	if(type == "StringEditor")
      	{
                  //return new FormItemStringEditorForDataGrid();
      		return <FormItemStringEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
      	}
      	else if(type == "DateEditor")
            {
      		return <FormItemDateEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
      	}
      	else if(type == "TimeEditor")
      	{
      		return <FormItemTimeEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
            }
            else if(type == "DateTimeEditor")
            {
                 // return <FormItemDateTimeEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
            }
      	else if(type == "LongEditor")
      	{
      		return <FormItemLongEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
      	}
      	else if(type == "DecimalEditor")
      	{
      		return <FormItemDecimalEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
      	}
      	//对于Boolean类型的DataGrid列 无项编辑器 由BooleanRenderer类替代
      	else if(type == "BooleanEditor")
      	{
      		return <FormItemBooleanRender test={1}/>;
      	}
      	else if(type == "EnumEditor")
      	{
      		return <FormItemEnumEditorForDataGrid key={item.id} xml={item} forLookup={forLookup}/>;
      	}
      }

      static getFormItemInstance(menuItemId,formId,item,parent,forLookup)
      {
            //console.log(FormItemUtil.formItemControls);
            let control = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(menuItemId,formId,item.id),forLookup);
            return control.getComponentInstance(parent,forLookup);

      }

      static setControlStyles(menuItemId,formId,innerId,styles)
      {
            if(!window.controlStyles)
                  window.controlStyles = {};
            let value;
            if(Array.isArray(styles))
                  value = styles;
            else
                  value = [styles];
            let key = menuItemId+"."+formId+"."+innerId;
            window.controlStyles[key] = value;
      }

      static setControlNoBindStyle(menuItemId,formId,innerId,styles)
      {
            if(!window.controlStyles)
                  window.controlStyles = {};
            let key = menuItemId+"."+formId+"."+innerId;
            window.controlStyles[key] = styles;
      }

      static getControlStyles(menuItemId,formId,innerId)
      {
            let result;
            if(window.controlStyles)
            {
                  let key = menuItemId+"."+formId+"."+innerId;
                  if(!window.controlStyles.hasOwnProperty(key))
                        result = null;
                  else
                        result = window.controlStyles[key];
            }
            return result;
      }

      static getDataGridUnderFormItem(itemControl,grids)
      {
            if(itemControl.classAlias == "FormItemDataGridControl")
            {
                  grids.push(itemControl);
                  return;
            }
            if(itemControl.childrenControl)
            {
                  for(let i = 0;i<itemControl.childrenControl.length;i++)
                  {
                        let childControl = itemControl.childrenControl[i];
                        FormItemUtil.getDataGridUnderFormItem(childControl,grids);
                  }
            }
      }
};

FormItemUtil.defaultProps = {
};

export default FormItemUtil;





// WEBPACK FOOTER //
// ./src/utils/FormItemUtil.js